import React from "react";
import { PhotoLibraryIcons } from "../../../../utils/B2B/PhotoLibraryContent";
import { IPhotoLibraryPhoto } from "../../../../interfaces/photoLibrary";
import "./PhotoLibraryPhotoItem.scss";

interface PhotoLibraryPhotoItemProps {
	isSelected: boolean;
	selectedIndex: number;
	isHovered: boolean;
	isDragging: boolean;
	isDragOver: boolean;
	hasCategory: boolean;
	showDeleteConfirm: boolean;
	showUnlinkConfirm: boolean;
	photo: IPhotoLibraryPhoto;
	onPhotoClick: () => void;
	onPhotoHoverStart: () => void;
	onPhotoHoverEnd: () => void;
	onPhotoDragStart: (e: React.DragEvent) => void;
	onPhotoDragEnd: () => void;
	onPhotoDragOver: (e: React.DragEvent) => void;
	onPhotoDrop: (e: React.DragEvent) => void;
	onPreviewClick: (e: React.MouseEvent) => void;
	onUnlinkClick: (e: React.MouseEvent) => void;
	onDeleteClick: (e: React.MouseEvent) => void;
	onConfirmDelete: (e: React.MouseEvent) => void;
	onCancelDelete: (e: React.MouseEvent) => void;
	onConfirmUnlink: (e: React.MouseEvent) => void;
	onCancelUnlink: (e: React.MouseEvent) => void;
}

const PhotoLibraryPhotoItem: React.FC<PhotoLibraryPhotoItemProps> = ({
	photo,
	isSelected,
	selectedIndex,
	isHovered,
	isDragging,
	isDragOver,
	hasCategory,
	showDeleteConfirm,
	showUnlinkConfirm,
	onPhotoClick,
	onPhotoHoverStart,
	onPhotoHoverEnd,
	onPhotoDragStart,
	onPhotoDragEnd,
	onPhotoDragOver,
	onPhotoDrop,
	onPreviewClick,
	onUnlinkClick,
	onDeleteClick,
	onConfirmDelete,
	onCancelDelete,
	onConfirmUnlink,
	onCancelUnlink,
}) => {

	return (
		<div
			className={`picker-photo ${isSelected ? "selected" : ""} ${isDragging ? "dragging-photo" : ""} ${isDragOver ? "drag-over-reorder" : ""}`}
			onClick={() => !showDeleteConfirm && !showUnlinkConfirm && onPhotoClick()}
			onMouseEnter={onPhotoHoverStart}
			onMouseLeave={onPhotoHoverEnd}
			draggable
			onDragStart={onPhotoDragStart}
			onDragEnd={onPhotoDragEnd}
			onDragOver={onPhotoDragOver}
			onDrop={onPhotoDrop}
		>
			<img src={photo.fileUrl} alt={photo.fileName} loading="lazy" />

			{isSelected && <div className="selection-badge">{selectedIndex + 1}</div>}

			{isHovered && !isSelected && !showDeleteConfirm && !showUnlinkConfirm && (
				<>
					<button className="photo-preview-btn" onClick={onPreviewClick} title="Preview">
						<PhotoLibraryIcons.Eye />
					</button>
					{!photo?.isProfileImage && hasCategory && (
						<button className="photo-unlink-btn" onClick={onUnlinkClick} title="Unlink from category">
							<PhotoLibraryIcons.Unlink />
						</button>
					)}
					{!photo?.isProfileImage && (
						<button className="photo-delete-btn" onClick={onDeleteClick} title="Delete">
							<PhotoLibraryIcons.Trash />
						</button>
					)}
				</>
			)}

			{showDeleteConfirm && (
				<div className="delete-confirm-overlay">
					<div className="delete-confirm-message">Delete image?</div>
					<div className="delete-confirm-actions">
						<button className="delete-confirm-btn confirm" onClick={onConfirmDelete} title="Delete">
							<PhotoLibraryIcons.Check />
						</button>
						<button className="delete-confirm-btn cancel" onClick={onCancelDelete} title="Cancel">
							<PhotoLibraryIcons.Close />
						</button>
					</div>
				</div>
			)}

			{showUnlinkConfirm && (
				<div className="unlink-confirm-overlay">
					<div className="unlink-confirm-message">Move to uncategorized?</div>
					<div className="unlink-confirm-actions">
						<button className="unlink-confirm-btn confirm" onClick={onConfirmUnlink} title="Confirm">
							<PhotoLibraryIcons.Check />
						</button>
						<button className="unlink-confirm-btn cancel" onClick={onCancelUnlink} title="Cancel">
							<PhotoLibraryIcons.Close />
						</button>
					</div>
				</div>
			)}
		</div>
	);
};

export default PhotoLibraryPhotoItem;
